<template>
<div>
  <h1 class="title">{{ pageTitle }}</h1>
  <p
    v-if="resTitle"
    class="is-size-5"
  >{{ resTitle }}</h3>
  <p
    v-if="resBody"
  >{{ resBody }}</p>

  <b-field
    v-if="isActivePasswordInput"
    :label="$t('form.NewPassword')"
    :type="checkEmpty(errors.password) ? '' : 'is-danger'"
    :message="checkEmpty(errors.password) ? '' : errors.password[0]"
  >
    <b-input
      type="password"
      v-model="password"
      :password-reveal="true"
      icon="lock"
      icon-pack="fas"
      @blur="validate('password')"
      @keyup.native.enter="keyDownEnter($event)"
      :placeholder="$t('common.password')"
    >
    </b-input>
  </b-field>

  <div class="field">
    <div class="control">
      <button
        class="button is-primary"
        :disabled="isLoading"
        @click="updatePassword()"
        v-text="$t('common.send')"
      ></button>
    </div>
  </div>
</div>
</template>

<script>
import { getAuth, isSignInWithEmailLink } from 'firebase/auth'
import utilUri from '@/util/uri'
import str from '@/util/str'
import site from '@/util/site'
import { Firebase } from '@/api'

export default {
  name: 'UserVerifyEmail',

  data () {
    return {
      pageTitle: '',
      resType: '',
      resTitle: '',
      resBody: '',
      email: '',
      password: '',
      errors: {},
      isActivePasswordInput: false,
    }
  },

  computed: {
    actionCode() {
      return this.$route.query.oobCode
    },

    hasErrors: function() {
      let hasError = false
      Object.keys(this.errors).map(field => {
        if (this.errors[field].length > 0) hasError = true
      })
      return hasError
    },
  },

  async created() {
    this.pageTitle = this.$t('page.EmailVerification')
    const currentUrl = window.location.href
    const auth = getAuth()
    if (isSignInWithEmailLink(auth, currentUrl)) {
      let email = window.localStorage.getItem('emailForSignIn')
      if (!email) {
        email = window.prompt('Please provide your email for confirmation')
      }
      if (email) {
        await this.handleSignInWithEmailLink(email, currentUrl)
      } else {
        this.showGlobalMessage(this.$t('msg["Verify Email Failed"]'))
        return
      }
    } else {
      const mode = this.$route.query.mode
      const continueUrl = this.$route.query.continueUrl
      const lang = this.$route.query.lang || 'en'

      switch (mode) {
        case 'resetPassword':
          // Display reset password handler and UI.
          this.pageTitle = this.$t('common.passwordReset')
          this.handleResetPassword(this.actionCode, continueUrl, lang)
          break;

        //case 'recoverEmail':
        //  // Display email recovery handler and UI.
        //  handleRecoverEmail(auth, actionCode, lang)
        //  break;

       case 'verifyEmail':
          const res = await this.handleVerifyEmail(this.actionCode)
          this.resType = res.type
          this.resTitle = res.title
          this.resBody = res.body
          break;

        default:
          // Error: invalid mode.
          this.showGlobalMessage(this.$t('error.400'))
      }
    }
  },

  methods: {
    async handleVerifyEmail(actionCode) {
      this.$store.dispatch('setLoading', true)
      try {
        const res = await Firebase.verifyEmail(actionCode)
        this.$store.dispatch('setUserEmailVerified', true)
        this.$store.dispatch('setLoading', false)

        return {
          'title': this.$t('msg["Verify Email Completed"]'),
          'body': '',
          'type': 'success',
        }
      } catch (err) {
        this.debugOutput(err)
        return {
          'title': this.$t('msg["Verify Email Failed"]'),
          'body': this.$t('msg["Check verification email"]'),
          'type': 'error',
        }
      }
    },

    async handleResetPassword(actionCode, continueUrl, lang) {
      this.$store.dispatch('setLoading', true)
      try {
        this.email = await Firebase.verifyPasswordResetCode(actionCode)
        this.$store.dispatch('setLoading', false)
        this.isActivePasswordInput = true
      } catch (err) {
        console.log(err)
        return {
          'title': this.$t('msg["Verify Email Failed"]'),
          'body': this.$t('msg["Check verification email"]'),
          'type': 'error',
        }
      }
    },

    async updatePassword() {
      this.validate('password')
      if (this.hasErrors) return

      this.$store.dispatch('setLoading', true)
      try {
        const res = await Firebase.confirmPasswordReset(this.actionCode, this.password)
        const vals = {
          email: this.email,
          password: this.password,
        }
        const userCredential = await Firebase.signIn(vals)
        const user = site.convUserObjForStore(userCredential.user, userCredential._tokenResponse.idToken)
        this.$store.dispatch('setUser', user)
        this.$store.dispatch('setLoading', false)
        this.$router.push('/')
      } catch (err) {
        console.log(err)
        return {
          'title': this.$t('msg["Verify Email Failed"]'),
          'body': this.$t('msg["Check verification email"]'),
          'type': 'error',
        }
      }
    },

    async handleSignInWithEmailLink(email, currentUrl) {
      this.$store.dispatch('setLoading', true)
      try {
        const userCredential = await Firebase.signInWithEmailLink(email, currentUrl)
        const user = site.convUserObjForStore(userCredential.user, userCredential._tokenResponse.idToken)
        this.$store.dispatch('setUser', user)
        window.localStorage.removeItem('emailForSignIn');
        this.$store.dispatch('setLoading', false)
        this.$router.push('/')
      } catch (err) {
        console.log(err)
        this.$store.dispatch('setLoading', false)
        this.showGlobalMessage(this.$t('msg["Verify Email Failed"]'))
      }
    },

    keyDownEnter() {
      if (event.keyCode !== 13) return
      this.updatePassword()
    },

    validate: function(field) {
      const key = 'validate' + str.capitalize(field)
      this[key]()
    },

    validatePassword: function() {
      this.initError('password')
      if (this.checkEmpty(this.password)) {
        this.errors.password.push(this.$t('msg["Password is required"]'))
      }
      if (this.password.length < 6) {
        this.errors.password.push(this.$t('msg["Password must be at least 6 characters"]'))
      }
    },

    initError: function(field) {
      this.$set(this.errors, field, [])
    },

    initErrors: function(field) {
      const keys = Object.keys(this.errors)
      if (!this.inArray(field, keys)) {
        this.initError(field)
      }
    },
  }
}
</script>

